import { Behavior } from '@babylonjs/core/Behaviors/behavior';
import { Vector3 } from '@babylonjs/core/Maths/math';
import { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh';
import { TransformNode } from '@babylonjs/core/Meshes/transformNode';

import { SlotLineChild } from '../../../interfaces/Slot';
import SlotLineChildNode from './slotLineChildNode';

export const SLOT_LINE_BEHAVIOR_NAME = 'SlotLineBehavior';
export default class SlotLineBehavior implements Behavior<AbstractMesh> {
  get name() {
    return SLOT_LINE_BEHAVIOR_NAME;
  }
  slotLineVector: Vector3;
  children: SlotLineChildNode[];

  constructor(readonly startNode: TransformNode, readonly endNode: TransformNode) {
    this.children = [];
    this.slotLineVector = endNode
      .getAbsolutePosition()
      .subtract(startNode.getAbsolutePosition())
      .normalizeToNew();
  }

  attach(_: AbstractMesh): void {}

  init(): void {}

  detach(): void {}

  public add(meshId: string, size: number, mesh: AbstractMesh, position: number) {
    const direction = this.slotLineVector;
    if (!size) {
      throw new Error(`Article ${meshId} must have size, but it's ${size}`);
    }

    const newAttachedChild = new SlotLineChildNode(meshId, mesh, size, direction);
    mesh.setParent(this.startNode);
    newAttachedChild.move(position);
    this.children = [...this.children, newAttachedChild];
  }

  public remove(meshId: string) {
    this.children = this.children.filter((child) => child.id !== meshId);
  }

  public moveOnPosition(meshId: string, position: number) {
    const child = this.children.find((child) => child.id === meshId);
    child.move(position);
  }

  public setNewArrangement(children: SlotLineChild[]) {
    children.forEach(({ id, position }) =>
      this.children.find((child) => child.id === id)?.move(position),
    );
  }
}
